"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notAny = undefined;
exports.isNull = isNull;
exports.isFalse = isFalse;
exports.cursorValueHasChanged = cursorValueHasChanged;
exports.hasCursorValue = hasCursorValue;
exports.withCursor = withCursor;
exports.withCursors = withCursors;
exports.withAnyCursor = withAnyCursor;

var _mori = require("mori");

/* START: Copied from common-js. */
function not(x) {
  return !x;
}

// https://clojuredocs.org/clojure.core/nil_q
function isNull(x) {
  return x === null;
}

var notAny = exports.notAny = (0, _mori.comp)(not, _mori.some);

// https://clojuredocs.org/clojure.core/false_q
function isFalse(x) {
  return x === false;
}
/* END: Copied from common-js.  */

function cursorValueHasChanged(cursor, currentState, newState) {
  return !(0, _mori.equals)((0, _mori.getIn)(currentState, cursor), (0, _mori.getIn)(newState, cursor));
}

function hasCursorValue(cursor, _, newState) {
  return not(isNull((0, _mori.getIn)(newState, cursor)));
}

function isPassingChecks(cursor, currentState, newState, checks) {
  return notAny(isFalse, (0, _mori.map)(function (check) {
    return check(cursor, currentState, newState);
  }, checks));
}

function withCursor(fn, cursor) {
  for (var _len = arguments.length, checks = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    checks[_key - 2] = arguments[_key];
  }

  return function (currentState, newState) {
    if (isPassingChecks(cursor, currentState, newState, checks)) {
      return fn(currentState, newState);
    }
  };
}

function withCursors(fn, cursors) {
  for (var _len2 = arguments.length, checks = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    checks[_key2 - 2] = arguments[_key2];
  }

  return function (currentState, newState) {
    var everyCursorHasPassedAllChecks = notAny((0, _mori.comp)(isFalse, function (cursor) {
      return isPassingChecks(cursor, currentState, newState, checks);
    }), cursors);

    if (everyCursorHasPassedAllChecks === true) {
      return fn(currentState, newState);
    }
  };
}

function withAnyCursor(fn, cursors) {
  for (var _len3 = arguments.length, checks = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    checks[_key3 - 2] = arguments[_key3];
  }

  return function (currentState, newState) {
    var someCursorHasPassedAllChecks = (0, _mori.some)(function (cursor) {
      return isPassingChecks(cursor, currentState, newState, checks);
    }, cursors);

    if (someCursorHasPassedAllChecks === true) {
      return fn(currentState, newState);
    }
  };
}